export const DATA_BACKGROUND = 'background';
export const CLASS_HEADER_CONTAINER = 'bnum-header-container';
export const CLASS_HEADER_LEFT = 'header-left';
export const CLASS_HEADER_RIGHT = 'header-right';
export const CLASS_HEADER_TITLE = 'header-title';
export const CLASS_HEADER_CUSTOM = 'header-custom';
export const CLASS_HEADER_MODIFIER = 'header-modifier';
export const PART_HEADER_CONTAINER = 'header-container';
export const PART_HEADER_LEFT = 'header-left';
export const PART_HEADER_RIGHT = 'header-right';
export const PART_HEADER_TITLE = 'header-title';
export const PART_HEADER_CUSTOM = 'header-custom';
export const ID_TITLE_TEXT = 'title-text';
export const ID_TITLE_CUSTOM = 'title-custom';
export const SLOT_NAME_LOGO = 'logo';
export const SLOT_NAME_TITLE = 'title';
export const SLOT_NAME_ACTIONS = 'actions';
export const SLOT_NAME_AVATAR = 'avatar';
export const EVENT_BACKGROUND_CHANGED = 'bnum-header:background.changed';
export const CSS_VARIABLE_BACKGROUND_IMAGE = '--bnum-header-background-image';
export const STATE_WITH_BACKGROUND = 'with-background';
